import store from "../store";

export default {
    getValidationFormStatus(details = {}, formValidation = {}) {
        // Validation object from ValidationObserver
        if (formValidation.invalid) return "error"; // If the form has been "touched" and contains an invalid field
        if (formValidation.valid) return "completed"; // If the form and input fields are valid

        // I've written this whilst positive for COVID - good times. So it's probably not the best
        return Object.keys(details).filter((key) => {
            if (typeof details[key] === "object") {
                // Used in special instances where it could contain nested objects
                if (details[key]) {
                    return Object.keys(details[key]).filter((subKey) => {
                        return details[key][subKey];
                    }).length;
                }
            }
            return details[key];
        }).length
            ? "incomplete" // If the form has been partially filled out
            : "";
    },

    /**
     * @param {*} step // The step in which to check against
     * @param {*} formDetails // List of the form inputs to check validation against
     * @param {*} observer // The observer object (from VeeValidate) to check the validation against
     * @param {*} isSoftCheck // Boolean to decide whether it should be a soft check and therefore does not validate the entire form
     * @param {*} isHardCheck // Boolean to decide whether it should be a hard check and should validate the form
     */
    async checkStepperStepStatus(step, formDetails, observer, isSoftCheck = true, isHardCheck = false) {
        if (observer.flags != undefined) {
            if ((isSoftCheck && observer.flags.dirty) || isHardCheck) {
                let status = this.getValidationFormStatus(formDetails, observer.flags);
                store.commit("setStepperStepStatus", { step: step - 1, status });
            }

            if (isHardCheck) {
                observer.validateWithInfo();
            }
        }
    },
};
